<template>
    <div id="announcement" v-html="body"></div>
</template>

<script>
export default {
  name: 'Announcement',
  props: [
      'body'
  ]
}
</script>